import { WEEKDAYS, formatClock } from "../lib/days";
import type { PlaceHoursPeriod } from "../types";
import ConfirmRemove from "./ConfirmRemove";
import { SelectField, TimeField } from "./fields";

type Props = {
  hours: PlaceHoursPeriod[];
  onChange: (next: PlaceHoursPeriod[]) => void;
};

function emptyPeriod(): PlaceHoursPeriod {
  return { open_day: 1, open_time: "09:00", close_day: 1, close_time: "18:00" };
}

export default function HoursEditor({ hours, onChange }: Props) {
  function update(i: number, patch: Partial<PlaceHoursPeriod>) {
    onChange(hours.map((row, idx) => (idx === i ? { ...row, ...patch } : row)));
  }

  return (
    <div className="space-y-3">
      {hours.length === 0 ? (
        <p className="text-sm text-slate-500">Aucun créneau. Ajoutez les horaires d’ouverture.</p>
      ) : null}
      {hours.map((row, i) => (
        <div key={`${row.open_day}-${i}`} className="grid grid-cols-1 items-center gap-3 rounded-2xl bg-mist px-4 py-3 sm:grid-cols-[1.2fr_1fr_1fr_auto]">
          <SelectField
            value={String(row.open_day)}
            onChange={(v) => update(i, { open_day: Number(v), close_day: Number(v) })}
            options={WEEKDAYS.map((d) => ({ value: String(d.value), label: d.label }))}
          />
          <TimeField value={formatClock(row.open_time)} onChange={(v) => update(i, { open_time: v })} />
          <TimeField value={formatClock(row.close_time)} onChange={(v) => update(i, { close_time: v })} />
          <ConfirmRemove question="Retirer ce créneau ?" onConfirm={() => onChange(hours.filter((_, idx) => idx !== i))} />
        </div>
      ))}
      <button type="button" className="text-sm font-medium text-violet" onClick={() => onChange([...hours, emptyPeriod()])}>
        Ajouter un créneau
      </button>
    </div>
  );
}
